import { UserEnum } from "../../types/userEnum";
import { FormDataController } from "../formController";
import { useNavigate } from "react-router-dom";
import useUserEnumQuery from "../../hooks/query/useUserEnumQuery";
import useUserEnumLogic from "../../hooks/logic/userEnumLogic";

const useUserEnumController = (id: string): FormDataController<UserEnum> => {
  const { useFetchById, useUpdate } = useUserEnumQuery();
  const { defaultUserEnum, getDisplayName } = useUserEnumLogic();
  const fetchById = useFetchById(id || "");
  const update = useUpdate();
  const navigate = useNavigate();

  const fetchData = async (): Promise<UserEnum> => {
    const res = await fetchById.refetch();
    const userEnumData = res.data;
    if (!userEnumData || res.isError) {
      throw new Error("UserEnum data not found");
    }
    return userEnumData;
  };

  const onSubmit = async (data: Partial<UserEnum>) => {
    const updateData: Partial<UserEnum> = {
      internal_notes: data.internal_notes,
      notes: data.notes,
      values: data.values,
    };

    let result = await update.mutateAsync({
      id,
      data: { _rev: data._rev, ...updateData },
    });
    if (!result || update.isError) {
      throw new Error("Failed to update UserEnum");
    }
    return result;
  };

  const title = (data: UserEnum) =>
    `Edit ${getDisplayName(data)}`;

  const navigateBack = () => navigate(-1);


  return {
    defaultValues: defaultUserEnum,
    isCreateMode: false,
    title,
    fetchData,
    onSubmit,
    formCallback: navigateBack,
  };
};

export default useUserEnumController;

